/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="row-fluid landing-page main-index">\n    ';
 
       if (layouts.length)
       { ;
__p += '\n        <div class="map-layouts col-lg-3">\n            <div class="panel panel-default main-panel">\n                <div class="panel-heading">\n                    <h1 class="panel-title">My Layouts</h1>\n                </div>\n                <div class="panel-body">\n                    <div class="app-row row-fluid">                        \n                        ';
 _.each(layouts, function(layout)
                            { 
                                var lay = layout.attributes ? layout.attributes : layout;;
__p += '                  \n                            <div class="app-cell col-sm-4 col-lg-12">\n                                <div class="layout_item">\n                                    <a data-ajax="false" data-toggle="tooltip" data-placement="top" title="' +
((__t = (lay.name)) == null ? '' : __t) +
'" class="btn1var" href="' +
((__t = (urlBuilder.url('/map/layout/' + layout.id))) == null ? '' : __t) +
'">' +
((__t = ( s.prune(lay.name, 17))) == null ? '' : __t) +
'</a>\n                                </div>\n                            </div>\n                        ';
}) ;
__p += '\n                    </div>\n                </div>          \n            </div>  \n        </div>\n    ';
} ;
__p += '\n    <div class="map-services col-lg-' +
((__t = (layouts.length ? '9' : '12')) == null ? '' : __t) +
'">\n        <div class="panel panel-default main-panel">\n            <div class="panel-heading">\n                <h1 class="panel-title">Map Services</h1>\n            </div>\n            <div class="panel-body">\n                <div class="service-container row-fluid">\n                    <div class="tab-view">\n                        <ul class="nav nav-tabs" role="tablist">\n                            ';
 var makeActive = true;;
__p += '\n                            ';
 _.each(services, function(serviceInfo, index){;
__p += '\n                                ';
 if(serviceInfo.services.length){ ;
__p += '\n                                    <li role="presentation" ' +
((__t = (makeActive ? 'class="active"' : '')) == null ? '' : __t) +
'><a href="' +
((__t = ( urlBuilder.url('/service/' + (index)))) == null ? '' : __t) +
'" aria-controls="service-tab-' +
((__t = (index)) == null ? '' : __t) +
'" role="tab" >' +
((__t = (serviceInfo.title)) == null ? '' : __t) +
'</a></li>\n                                    ';
 makeActive = false;;
__p += '\n                                ';
};
__p += '\n                            ';
});;
__p += '\n                        </ul>\n                        <div class="tab-content hidden-xs">\n                            ';
 makeActive = true;;
__p += '\n                            ';
 _.each(services, function(serviceInfo, index){;
__p += '\n                                ';
 if(serviceInfo.services.length){ ;
__p += '\n                                    <div role="tabpanel" class="tab-pane ' +
((__t = ( (makeActive ? 'active' : ''))) == null ? '' : __t) +
'" id="service-tab-' +
((__t = ((index))) == null ? '' : __t) +
'">\n                                        <table class="table">\n                                            <tr class="header-row"><th>Name</th></tr>\n                                            ';
 _.each(serviceInfo.services, function(service){;
__p += '\n                                                <tr><td><a href="' +
((__t = ( urlBuilder.url('/map/service/' + service.id))) == null ? '' : __t) +
'">' +
((__t = (service.name)) == null ? '' : __t) +
'</a><td></tr>\n                                            ';
 });
__p += '\n                                        </table>\n                                    </div>\n                                    ';
 makeActive = false;;
__p += '\n                                ';
};
__p += '\n                            ';
});;
__p += '\n                        </div>\n                    </div>\n                    \n                </div>\n            </div>          \n        </div>\n    </div>\n</div>';

}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/main/Index.ejs
// module id = 940
// module chunks = 1